import TabTriggerLoading from '@/common/components/Tabs/components/TabTriggerLoading'
import { Tabs } from '@/common/components/ui/tabs'
import { tabsDefaultWithFlexGrowClassName } from '@/common/constants/tabsDefaultClassName.constant'
import { useGetCurrentTab } from '@/common/hooks/useGetCurrentTab'
import MaintenanceWorkflowForwardingShowLoading from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/MaintenanceWorkflowForwardingShowLoading'
import MaintenanceDescription from '@/features/maintenanceWorkflow/pages/Show/components/tabs/MaintenanceDescription'
import { useParams } from 'react-router-dom'

const MaintenanceWorkflowLoading = () => {
  const { id } = useParams()

  const currentTab = useGetCurrentTab(`/maintenance-workflows/${id}`)

  return (
    <div className="flex flex-col gap-6">
      <Tabs>
        <TabTriggerLoading {...tabsDefaultWithFlexGrowClassName} skeletonsCount={2} />
      </Tabs>

      {currentTab && <MaintenanceWorkflowForwardingShowLoading />}
      {!currentTab && <MaintenanceDescription workflow={undefined} />}
    </div>
  )
}

export default MaintenanceWorkflowLoading
